import { useContext, useMemo } from 'react'
import { useParams, Navigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/template-editor'
import Editor from '/components/editor/index'
import Menu from '/components/templates/template-nav-menu'

const TemplateEditor = () => {

  const { templateId } = useParams()
  const { loadingTemplates, templates } = useContext(AppContext)

  const template = useMemo(() => templates.filter(t => t.template_id === templateId)[0], [templates, templateId])

  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""}` : "",[template])

  if (!loadingTemplates && !template) return <Navigate to="/templates" replace />

  return (
    <PageWrapper title={template ? `Template Editor (${template.name})` : 'Template Editor'} HelpText={HelpText} showWait heading={heading} selectedTemplate={template} menu={<Menu template={template} />}>
      <Editor />
    </PageWrapper>
  )
}

export default TemplateEditor
